<script>
import BackIcon from "@/components/BackIcon.vue";
import {mapMutations} from "vuex";
import {myPath} from "@/utils/constant";

export default {
  name: "RegisterSelectPage",
  components: {BackIcon},
  data() {
    return {
      items: [],
      selectEmployee: ""
    }
  },

  mounted() {
    console.log("RegisterSelectPage mounted")

    this.items = this.$store.state.pageSetting.find(item => item.url === myPath.localRegister).items

    this.selectEmployee = this.$route.params.employee
    if (this.selectEmployee) {
      this.setSelectEmployee(this.selectEmployee)
    } else {
      this.selectEmployee = this.$store.state.selectEmployee
    }
  },

  methods: {
    ...mapMutations(["setSelectEmployee"]),
    onItemClick(item) {
      console.log("RegisterSelectPage onItemClick", item)
      this.$router.push({name: item.url, params: {employee: this.selectEmployee}})
    },

    onBackClick() {
      this.$router.back()
    }
  }

}
</script>

<template>
  <div class="select-page-box">
    <div class="main-header">
      <span class="title"></span>
      <back-icon></back-icon>
    </div>

    <div class="main-content">
      <div class="title">
        <span>请选择登记方式</span>
      </div>

      <div class="my-card-list">
        <div v-for="card in items" :key="card.url" class="el-card-box">
          <el-card @click.native="onItemClick(card)" class="el-card-small" shadow="always">
            <div class="el-card-content">
              <img :src="card.image" alt="icon" style="height: 50px">
              <div> {{ card.title }}</div>
            </div>
          </el-card>
        </div>
      </div>

    </div>

  </div>
</template>

<style scoped lang="less">



</style>
